<template>
  <brightsignnetwork />
</template>

<script>
  import Brightsignnetwork from './dashboard/brightsignnetwork/Index'
  export default {
    components: {
      Brightsignnetwork
    },
  }
</script>
